import { Component, EventEmitter, Input, Output } from '@angular/core';
import { texts } from './requirements-editor-list.texts';

@Component({
    selector: 'sc-requirements-editor-list',
    templateUrl: './requirements-editor-list.component.html',
    styleUrls: ['./requirements-editor-list.component.scss'],
    standalone: false
})
export class RequirementsEditorListComponent {

  private readonly MUST_HAVE_PRIORITIES = ['MustHave', 'Core'];
  private readonly VISIBLE_REQUIREMENT_TYPES = ['Skill', 'Industry', 'Degree', 'Language', 'Experience', 'Custom'];

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  @Input()
  project: any;

  @Input()
  priority: any;

  @Input()
  readonly = false;

  @Input()
  hideInvisible = false;

  @Input()
  size = 'md';

  @Input()
  showCore = false;

  @Output()
  onAdd = new EventEmitter<any>();

  add(type) {

    if (this.readonly) return;

    this.project.Profile.Requirements.forEach(r => r.isSelected = false);

    var requirement = {
      Type: type,
      Priority: this.priority,
      Alternatives: [''],
      Level: '',
      Min: 0,
      Max: 0,
      isSelected: true
    };

    if (type == 'Language')
    {
      requirement.Level = 'Basic';
    }

    this.project.Profile.Requirements.push(requirement);
    this.onAdd.next(requirement);
  }

  toggleSelect(r)
  {
    if (this.readonly) return;
    r.isSelected = !r.isSelected;
  }

  matchesPriority(requirement: any) {
    if (this.priority === 'MustHave') {
      return this.MUST_HAVE_PRIORITIES.includes(requirement.Priority);
    }

    return requirement.Priority === this.priority;
  }

  isVisible(requirement: any) {
    return this.VISIBLE_REQUIREMENT_TYPES.includes(requirement?.Type) && (!this.hideInvisible || !requirement?.IsHidden);
  }

  hasExperienceRequirement() {
    return this.project.Profile.Requirements.some(r => r.Type == 'Experience' && this.matchesPriority(r));
  }

}
